import { Stack, Typography } from "@mui/material";
import { ControlException, FindingException } from "~/operations";
import { FormatDateYearTime } from "~/lib/date";

type Props = {
  exception: FindingException | ControlException | null;
};
export const ExceptionTooltipContent = ({ exception }: Props) => {
  if (!exception) return "";

  return (
    <Stack>
      {exception?.author && (
        <Typography
          sx={{ fontWeight: "700", fontSize: 10, color: "text.secondary" }}
        >
          Created by{" "}
          <Typography
            component="span"
            sx={{ fontSize: 10, color: "text.secondary" }}
          >
            {exception?.author.name} on{" "}
            {FormatDateYearTime(exception?.createdAt)}
          </Typography>
        </Typography>
      )}
      <Typography sx={{ fontSize: 10 }}>{exception?.justification}</Typography>
    </Stack>
  );
};
